// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: ciW4UelrpP
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import Select from "../../Select"; // plasmic-import: nRNBFuAA1Vp/component
import Button from "../../Button"; // plasmic-import: qD6dz0yVMKR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicInviteUserModal.module.css"; // plasmic-import: ciW4UelrpP/css

createPlasmicElementProxy;

export const PlasmicInviteUserModal__VariantProps = new Array();

export const PlasmicInviteUserModal__ArgProps = new Array();

const $$ = {};

function PlasmicInviteUserModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "emailInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: p.generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "select.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox___1Nx81)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__tgOce
          )}
        >
          <React.Fragment>
            <span
              className={"plasmic_default__all plasmic_default__span"}
              style={{ fontWeight: 500 }}
            >
              {"Email"}
            </span>
          </React.Fragment>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__tjzh6)}>
        {(() => {
          const child$Props = {
            className: classNames("__wab_instance", sty.emailInput),
            onChange: p.generateStateOnChangePropForCodeComponents(
              $state,
              "value",
              ["emailInput", "value"],
              AntdInput_Helpers
            ),
            placeholder: "Enter Email",
            value: p.generateStateValueProp($state, ["emailInput", "value"])
          };
          p.initializeCodeComponentStates(
            $state,
            [
              {
                name: "value",
                plasmicStateName: "emailInput.value"
              }
            ],

            [],
            AntdInput_Helpers ?? {},
            child$Props
          );
          return (
            <AntdInput
              data-plasmic-name={"emailInput"}
              data-plasmic-override={overrides.emailInput}
              {...child$Props}
            />
          );
        })()}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__b9Iev)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__nWduv
          )}
        >
          <React.Fragment>
            <span
              className={"plasmic_default__all plasmic_default__span"}
              style={{ fontWeight: 500 }}
            >
              {"Select Role"}
            </span>
            <React.Fragment>
              {" (or add new role and select your permissions)"}
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"selectRoleStack"}
        data-plasmic-override={overrides.selectRoleStack}
        className={classNames(projectcss.all, sty.selectRoleStack)}
      >
        <Select
          data-plasmic-name={"select"}
          data-plasmic-override={overrides.select}
          className={classNames("__wab_instance", sty.select)}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["select", "value"])(
              eventArgs[0]
            );
          }}
          options={[
            { value: "option1", label: "Option 1" },
            { value: "option2", label: "Option 2" }
          ]}
          value={p.generateStateValueProp($state, ["select", "value"])}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__ieXek)}>
        <Button
          data-plasmic-name={"sendInviteBtn"}
          data-plasmic-override={overrides.sendInviteBtn}
          className={classNames("__wab_instance", sty.sendInviteBtn)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__fgSxv
            )}
          >
            {"Send invite"}
          </div>
        </Button>
        <Button
          data-plasmic-name={"addRoleBtn"}
          data-plasmic-override={overrides.addRoleBtn}
          className={classNames("__wab_instance", sty.addRoleBtn)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__hUms6
            )}
          >
            {"Add Role"}
          </div>
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "emailInput",
    "selectRoleStack",
    "select",
    "sendInviteBtn",
    "addRoleBtn"
  ],

  emailInput: ["emailInput"],
  selectRoleStack: ["selectRoleStack", "select"],
  select: ["select"],
  sendInviteBtn: ["sendInviteBtn"],
  addRoleBtn: ["addRoleBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInviteUserModal__ArgProps,
          internalVariantPropNames: PlasmicInviteUserModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInviteUserModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInviteUserModal";
  } else {
    func.displayName = `PlasmicInviteUserModal.${nodeName}`;
  }
  return func;
}

export const PlasmicInviteUserModal = Object.assign(
  // Top-level PlasmicInviteUserModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    emailInput: makeNodeComponent("emailInput"),
    selectRoleStack: makeNodeComponent("selectRoleStack"),
    select: makeNodeComponent("select"),
    sendInviteBtn: makeNodeComponent("sendInviteBtn"),
    addRoleBtn: makeNodeComponent("addRoleBtn"),
    // Metadata about props expected for PlasmicInviteUserModal
    internalVariantProps: PlasmicInviteUserModal__VariantProps,
    internalArgProps: PlasmicInviteUserModal__ArgProps
  }
);

export default PlasmicInviteUserModal;
/* prettier-ignore-end */
